/**
 * Учёт событий виджета, которых сервер иначе не видит (25.09): отказ файла до запроса
 * (формат, размер, длина, число файлов, рамки фото) и открытие тримера. Шлём и забываем:
 * ошибка учёта никогда не мешает человеку и не ждёт ответа. Одинаковое событие чаще
 * раза в две секунды не повторяем (двойной клик по инпуту).
 */
import { api } from './client'

export type RejectField = 'image' | 'reference_images' | 'video' | 'reference_videos' | 'reference_audios'
export type RejectReason = 'format' | 'too_big' | 'too_many' | 'too_short' | 'too_long' | 'total_seconds' | 'dimensions'

export interface ClientEventPayload {
	kind: 'upload_rejected' | 'trim_opened'
	model?: string
	field?: RejectField
	reason?: RejectReason
	detail?: string
	page?: string
}

const recent = new Map<string, number>()
const DEDUPE_MS = 2000

/** Ключ для склейки повторов; экспортирован ради теста. */
export function eventKey(p: ClientEventPayload): string {
	return [p.kind, p.model ?? '', p.field ?? '', p.reason ?? '', p.detail ?? ''].join('|')
}

export function shouldSend(p: ClientEventPayload, now = Date.now()): boolean {
	const key = eventKey(p)
	const last = recent.get(key)
	if (last != null && now - last < DEDUPE_MS) return false
	recent.set(key, now)
	if (recent.size > 200) recent.clear()
	return true
}

function send(p: ClientEventPayload): void {
	if (!shouldSend(p)) return
	const page = typeof window !== 'undefined' ? window.location.pathname.slice(0, 120) : undefined
	void api.request('/api/v1/client-events', { method: 'POST', body: { ...p, page } }).catch(() => { /* учёт не мешает человеку */ })
}

export function reportUploadRejected(p: { model?: string; field: RejectField; reason: RejectReason; detail?: string }): void {
	send({ kind: 'upload_rejected', ...p, detail: p.detail?.slice(0, 120) })
}

export function reportTrimOpened(p: { model?: string; field: 'reference_videos' | 'reference_audios'; detail?: string }): void {
	send({ kind: 'trim_opened', ...p, detail: p.detail?.slice(0, 120) })
}
